import { render, staticRenderFns } from "./StoriesStatistic.vue?vue&type=template&id=cca4bd18&scoped=true&"
import script from "./StoriesStatistic.vue?vue&type=script&lang=ts&"
export * from "./StoriesStatistic.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesStatistic.vue?vue&type=style&index=0&id=cca4bd18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca4bd18",
  null
  
)

export default component.exports